import { Observable } from 'rxjs';

export interface GetBudgetFundParameters {
  fund: string,
  year: string,
  campus: string,
  fund_source: string,
  pap_description: string,
  allotment_class: string
}

export interface ApiResponse {
  code: number,
  message: any
}

export abstract class FundData {
  abstract getFund(): Observable<ApiResponse>;
  // abstract getFundSysref(): Observable<ApiResponse>;
  // abstract getCategory(): Observable<ApiResponse>;
  abstract getTypeAndDescription(fund: string): Observable<ApiResponse>;
  // abstract getBudgetFund(budgetFundParam: GetBudgetFundParameters): Observable<ApiResponse>;
  // abstract getFUndSourceReference(code: string): Observable<ApiResponse>;
}
